import { Component } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-sponsors',
    templateUrl: 'sponsors.html',
})
export class SponsorsPage {

    private sponsors: any;
    private goldSponsors: any;
    private platinumSponsors: any;
    private familiaSponsors: any;


    constructor(private db: AngularFirestore) {
        this.sponsors = "platinum";
        this.goldSponsors = [];
        this.platinumSponsors = [];
        this.familiaSponsors = [];
    }

    ionViewDidLoad() {
        this.loadSponsors();
    }

    loadSponsors() {
        this.db.doc("other/sponsors").valueChanges().subscribe(sponsors => {
            this.familiaSponsors = sponsors['familia'];
            this.goldSponsors = sponsors['gold'];
            this.platinumSponsors = sponsors['platinum'];
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/sponsors/sponsors.ts